<div class="logs-panel">
  <!-- Header: cím + stats -->
  <div class="panel-header">
    <div class="header-title">
      <mat-icon>bug_report</mat-icon>
      <h3>Backend logok</h3>
    </div>
    <div class="header-actions">
      <button
        mat-icon-button
        (click)="refresh()"
        matTooltip="Frissítés"
        [disabled]="isLoading">
        <mat-icon [class.spinning]="isLoading">refresh</mat-icon>
      </button>
    </div>
  </div>

  <!-- Stats badge sor -->
  @if (stats) {
  <div class="stats-row">
    <span class="stats-label">Utolsó 24 óra:</span>
    @if (stats.warning_24h > 0) {
      <span class="stat-badge level-warning">
        <mat-icon>warning</mat-icon>
        {{ stats.warning_24h }} WARNING
      </span>
    }
    @if (stats.error_24h > 0) {
      <span class="stat-badge level-error">
        <mat-icon>error</mat-icon>
        {{ stats.error_24h }} ERROR
      </span>
    }
    @if (stats.critical_24h > 0) {
      <span class="stat-badge level-critical">
        <mat-icon>dangerous</mat-icon>
        {{ stats.critical_24h }} CRITICAL
      </span>
    }
    @if (stats.warning_24h === 0 && stats.error_24h === 0 && stats.critical_24h === 0) {
      <span class="stats-empty">Nincs hibabejegyzés</span>
    }
  </div>
  }

  <!-- Szűrők -->
  <div class="filters-row">
    <div class="level-toggles">
      @for (level of availableLevels; track level) {
        <button
          class="level-toggle"
          [class]="getLevelClass(level)"
          [class.active]="isLevelActive(level)"
          (click)="toggleLevel(level)">
          {{ level }}
        </button>
      }
    </div>
    <app-delete-icon-button
      tooltip="Összes log törlése"
      (clicked)="deleteAll()">
    </app-delete-icon-button>
    <mat-form-field appearance="outline" class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        type="text"
        placeholder="Keresés üzenetben / traceback-ben..."
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange($event)" />
    </mat-form-field>
  </div>

  <!-- Loading -->
  @if (isLoading && logs.length === 0) {
  <div class="loading-state">
    <mat-spinner diameter="32"></mat-spinner>
    <span>Betöltés...</span>
  </div>
  }

  <!-- Error -->
  @if (errorMessage && logs.length === 0) {
  <div class="error-state">
    <mat-icon>error_outline</mat-icon>
    <span>{{ errorMessage }}</span>
    <button mat-stroked-button (click)="refresh()">Újrapróbálás</button>
  </div>
  }

  <!-- Üres állapot -->
  @if (!isLoading && !errorMessage && logs.length === 0) {
  <div class="empty-state">
    <mat-icon>check_circle_outline</mat-icon>
    <span>Nincs log bejegyzés a kiválasztott szűrőkkel.</span>
  </div>
  }

  <!-- Lista -->
  @if (logs.length > 0) {
  <div class="logs-list">
    @for (log of logs; track trackByLogId($index, log)) {
      <div class="log-row" (click)="openDetail(log)">
        <div class="log-row-top">
          <span class="level-chip" [class]="getLevelClass(log.level)">
            {{ log.level }}
          </span>
          <span class="timestamp">{{ log.timestamp | date:'MM-dd HH:mm:ss' }}</span>
          <span class="logger-name" [matTooltip]="log.logger_name">
            {{ log.logger_name }}
          </span>
          @if (log.has_traceback) {
          <mat-icon
            class="traceback-indicator"
            matTooltip="Stack trace elérhető">
            stack_star
          </mat-icon>
          }
        </div>
        <div class="log-message" [matTooltip]="log.message">
          {{ truncateMessage(log.message) }}
        </div>
        @if (log.user_name || log.request_path) {
        <div class="log-row-bottom">
          @if (log.user_name) {
            <span class="user">
              <mat-icon>person</mat-icon>{{ log.user_name }}
            </span>
          }
          @if (log.request_path) {
            <span class="request">
              <mat-icon>http</mat-icon>{{ log.request_method }} {{ log.request_path }}
            </span>
          }
        </div>
        }
      </div>
    }
  </div>
  }

  <!-- Pagination -->
  @if (total > 0) {
  <mat-paginator
    [length]="total"
    [pageSize]="pageSize"
    [pageIndex]="page - 1"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChange($event)"
    [showFirstLastButtons]="true">
  </mat-paginator>
  }
</div>
